import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ButtonComponent from '../Button.component';
import BaseAlertComponent, {
  BaseAlert2Props,
  StyledBaseAlertBodyIcon,
} from './BaseAlert.component';
import { ALERT_ACTION_ENUM } from '../../types/action.types';
import { useModalManager } from '../../hooks/ModalManager.hook';
import ErrorIcon from '../Icons/Error.icon';

const StyledErrorAlert = styled.div`
  ${StyledBaseAlertBodyIcon} {
    color: ${({ theme }) => theme.colors.RED.R400};
  }
`;

const ERROR_ICON_SIZE = 42;

const ErrorAlertComponent = ({
  header,
  onClose,
  children,
}: BaseAlert2Props) => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();

  const handleClose = (action: ALERT_ACTION_ENUM) => {
    onClose && onClose(action);
    closeModal();
  };

  return (
    <StyledErrorAlert>
      <BaseAlertComponent
        header={header || t('Error')}
        icon={<ErrorIcon width={ERROR_ICON_SIZE} height={ERROR_ICON_SIZE} />}
        footer={
          <React.Fragment>
            <ButtonComponent
              handleClick={() => handleClose(ALERT_ACTION_ENUM.OK)}
            >
              {t('OK')}
            </ButtonComponent>
          </React.Fragment>
        }
        onClose={() => handleClose(ALERT_ACTION_ENUM.OK)}
      >
        {children}
      </BaseAlertComponent>
    </StyledErrorAlert>
  );
};

export default ErrorAlertComponent;
